import { createSelector } from '@ngrx/store';
import { selectChangePasswordState } from './change-password.state';
import { ChangePasswordState } from './change-password.models';

export const selectChangePassword = createSelector(
    selectChangePasswordState,
    (state: ChangePasswordState) => state
);
